export default {"src":"/frontend-static/_next/static/media/local-support.76d72df0.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};